import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { NikoOrderHistoryListViewStore } from "../stores";
import { NikoOrderHistoryListTemplate } from "themes/application/niko-facility-order-us-intake/pages";

@setCurrentView(rootStore => new NikoOrderHistoryListViewStore(rootStore), "nikoOrderHistoryListViewStore")
@observer
class NikoOrderHistoryList extends React.Component {
    render() {
        return <NikoOrderHistoryListTemplate {...this.props} />;
    }
}

export default NikoOrderHistoryList;